import type { Identifier } from "react-admin";
import { AuditFields, CommonFields, CommonStatus, PartnerRef } from "./common";
import { User } from "./user";
import { DateYMDString } from "./date";

export const ClientStatus = {
  BUILDING: "building",
  APPROVED: CommonStatus.APPROVED,
  ACTIVE: CommonStatus.ACTIVE,
  INACTIVE: CommonStatus.INACTIVE,
  PAUSED: "paused",
} as const;

export type ClientStatusType = (typeof ClientStatus)[keyof typeof ClientStatus];

export interface ClientCalculations {
  claim_count?: number;
  claimant_count?: number;
  amt_claim_submitted?: number;
  amt_reimbursement?: number;
  amt_adjusted?: number;
  amt_denied?: number;
}

export interface ClientContact {
  contact_name: string;
  email: string;
  phone?: string;
  job_title?: string;
  is_primary?: boolean;
  is_verified?: boolean;
  verfiied_by_user_id_ref?: string;
  verified_datetime?: DateYMDString;
  verified_by?: User;
}

/**
 * Base client interface - fields that are in both create and read
 */
interface ClientBase {
  client_legal_name: string; // Required by backend validation  client_contact_name: string; // Required by backend validation
  client_short_name?: string;
  contacts?: ClientContact[];
  primary_contact?: number;
  client_state_headquartered?: string;
  client_parent_co?: string;
  broker_agent_of_record?: string;
  has_children_co?: boolean;
  client_status?: ClientStatusType;
  has_active_policy?: boolean;
  calculations?: ClientCalculations;
}

/**
 * Full client record from the API - includes server-managed fields
 */
export interface Client extends ClientBase, CommonFields, AuditFields, PartnerRef {
  // Source documents - read-only, populated by backend
  source_documents?: Identifier[];
}

/**
 * Payload for creating a new client
 */
export interface ClientCreate extends ClientBase {
  // Calculations are server-managed, not included in create payload
  // Source documents would be handled separately
}
